import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../store/authProvider";
import { exit_icon } from "../../../icons/exit";
import { description_icon } from "../../../icons/Description";
import ConvertToArabicNumbers from "../../../utils/convert_numbers";
import { circle_add } from "../../../icons/circle_add";
import { motion } from "framer-motion";
import { EmptyStarIcon, FullStarIcon } from "../../../icons/star";
import Client from "../../../utils/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const DetailsModal = ({
  offer,
  setShowModal,
  setShowContactModal,
  setShowOrderModal,
  states,
  cities_data,
  markets_data,
  type,
  favoriteOffers,
}) => {
  const { isAuth } = useAuth();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (newTodo) => {
      return Client.post(`/favorites/${offer.id}`, { favorite_type: "input" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("favorites");
    },
  });
  const navigator = useNavigate();
  const addFavorites = async () => {
    // Client.post(`/favorites/${offer.id}`, { favorite_type: "i" });

    mutation.mutate();
  };
  const user_id = localStorage.getItem("user_id");
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0, transition: { duration: 0.1 } }}
        transition={{ duration: 0.2 }}
        className="fixed inset-0 z-[10000] flex mx-2 lg:mx-0 items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      >
        <div className="relative max-w-[480px] min-w-[350px] mx-auto my-6">
          {/*content*/}
          <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-center justify-center p-5 rounded-t border-slate-200 ">
              <div className="w-full flex items-center justify-between">
                <div
                  className="text-red-600 w-8"
                  onClick={() => setShowModal(false)}
                >
                  {exit_icon}
                </div>

                <div
                  className="text-gray-500 w-8 active:scale-110"
                  onClick={addFavorites}
                >
                  {favoriteOffers.map((e) => e.id).includes(offer.id)
                    ? FullStarIcon
                    : EmptyStarIcon}
                </div>
              </div>
            </div>
            {/*body*/}
            <div className="flex justify-center h-[130px] bg-center bg-no-repeat bg-flipped-logo items-center">
              <img
                src={offer.input_category.image}
                className=" object-cover h-[8rem] self-center "
                alt=""
              />
            </div>

            <div className="w-full flex justify-center items-center font-bold mt-2 text-lg">
              {offer.input_category.name}
            </div>

            <div className="relative  max-h-[18rem] scrollbar-thin scrollbar-thumb-primary scrollbar-track-slate-200 overflow-y-auto flex-auto px-3 border-2 my-4 mx-3 rounded-lg">
              <div className="flex flex-col gap-2 my-3" dir="rtl">
                <ModalTable
                  description="إسم المنتج"
                  value={offer.name}
                  icon={description_icon}
                />
                {offer.description && (
                  <ModalTable
                    description="الوصف  "
                    value={offer.description}
                    icon={description_icon}
                  />
                )}

                <ModalTable
                  description="الولاية  "
                  value={states.find((e) => e.id === offer.state).name}
                />

                {offer.city && (
                  <ModalTable
                    description="المدينة  "
                    value={cities_data.find((e) => e.id === offer.city).name}
                  />
                )}
                {offer.market && (
                  <ModalTable
                    description="السوق  "
                    value={markets_data.find((e) => e.id === offer.market).name}
                  />
                )}
                {/* <ModalTable
                  description="الكمية  "
                  value={`${ConvertToArabicNumbers(offer.quantity)} ${
                    offer._unit.name
                  }`}
                /> */}
                {offer.price && (
                  <ModalTable
                    description="السعر  "
                    value={`${Number(offer.price).toLocaleString(
                      "en-US"
                    )} جنيه سوداني `}
                  />
                )}
                {offer.ingredients && (
                  <ModalTable
                    description="المكونات"
                    value={offer.ingredients}
                  />
                )}
                {offer.application && (
                  <ModalTable
                    description="طريقة الإستخدام"
                    value={offer.application}
                  />
                )}
                {offer.dose && (
                  <ModalTable description="الجرعة" value={offer.dose} />
                )}
                {offer.cautions && (
                  <ModalTable description="التحذيرات" value={offer.cautions} />
                )}
                {offer.storing && (
                  <ModalTable
                    description="صلاحية التخزين"
                    value={offer.storing}
                  />
                )}
                {offer.quality_certificate && (
                  <ModalTable
                    description="شهادة الجودة"
                    value={offer.quality_certificate}
                  />
                )}
              </div>
            </div>

            {/*footer*/}
            <button
              className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
              type="button"
              onClick={() => (
                setShowModal(false),
                isAuth
                  ? (setShowOrderModal(true),
                    Client.post("/admin/logs", {
                      user_id: isAuth ? user_id : null,
                      action: "Product Order",
                      product_type: "Inputs Product",
                      product_id: offer.id.toString(),
                    }))
                  : navigator("/signin")
              )}
            >
              <div>طلب</div>
              {circle_add}
            </button>
          </div>
        </div>
      </motion.div>
      <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
    </>
  );
};

export default DetailsModal;

const ModalTable = ({ description, value }) => {
  return (
    <div className="flex gap-4 ">
      <div className="flex ">
        <div className=" text-sm w-[80px] leading-relaxed font-bold">
          {description}
        </div>
        <div className="text-black font-bold">:</div>
      </div>

      <div className="text-sm leading-relaxed font-bold ">{value}</div>
    </div>
  );
};
